const cookieBar = document.querySelector('.js-cookie-bar');
const cookieBarActive = document.querySelector('.js-cookie-bar-active');
const changePreferencesToggles = document.querySelectorAll('.js-change-cookie-preferences');

function openCookieBar() {
  cookieBar.showModal();
  cookieBar.focus();
}

function showPreferences() {
  cookieBar.classList.add('show-preferences');

  if (!cookieBar.open) {
    openCookieBar();
  }
}

if (cookieBar) {
  // Polyfill registration
  dialogPolyfill.registerDialog(cookieBar);

  if (cookieBarActive) {
    openCookieBar();
  }

  if (changePreferencesToggles.length > 0) {
    changePreferencesToggles.forEach((toggle) => toggle.addEventListener('click', showPreferences));
  }

  // Prevent default cancel behaviour on dialog (on escape)
  cookieBar.addEventListener('cancel', (event) => event.preventDefault());
}
